import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Cookies from "js-cookie";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function AddBackup() {
    const navigate = useNavigate();
    const API_URL = BASE_URL + "/addbackup";

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const fileName = formData.get("fname");
        const file = formData.get("fpath");

        if (!fileName || !file || file.size === 0) {
            toast.error("All fields are required!");
            return;
        }

        const uploadData = new FormData();
        uploadData.append("fileName", fileName);
        uploadData.append("file", file); // This must match `upload.single('file')` in backend

        axios.post(API_URL, uploadData, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "multipart/form-data"
            }
        })
        .then(res => {
            toast.success("Backup file added successfully.");
            setTimeout(() => {
                navigate("/backupfiles");
            }, 2000);
        })
        .catch(error => {
            console.error(error);
            toast.error("Upload failed. Please try again.");
        });
    };

    return (
        <div className="container">
            <ToastContainer />
            <h2>Add Backup</h2>
            <br />
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-sm-6">
                        <input
                            type="text"
                            placeholder="Enter File Name"
                            className="form-control"
                            name="fname"
                            required
                        />
                    </div>
                    <div className="col-sm-6">
                        <input
                            type="file"
                            className="form-control"
                            name="fpath"
                            accept=".csv"
                            required
                        />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-sm-6">
                        <button type="submit" className="btn btn-primary">
                            Upload File
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}
